import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#1D1D1D",
      "fill-rule": "evenodd",
      "clip-path": "url(#i-1646090477__a)",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M19.876 8.992a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 12 9H1a1 1 0 0 1 0-2h11c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 20 7h3a1 1 0 1 1 0 2h-3a1.01 1.01 0 0 1-.124-.008ZM19 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0ZM4.124 16.008a4.002 4.002 0 0 1 7.752 0c.04-.005.082-.008.124-.008h11a1 1 0 1 1 0 2H12c-.042 0-.083-.003-.124-.008a4.002 4.002 0 0 1-7.752 0c-.04.005-.082.008-.124.008H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008ZM5 17a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1646090477__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon_filter"}) } }